// IMPORT
    // MODULE(S)
        import React, { useRef } from 'react';
        import PropTypes from 'prop-types';
        import { sortableHandle, sortableElement } from 'react-sortable-hoc';
        import TextareaAutosize from 'react-textarea-autosize';
    // STYLE(S)
        import '../sass/Todo.scss';



// EXTERNAL CONTENT
    // TOOL : sortableHandle + sortableElement => Info : To drag and drop todos and sort them
        const DragHandle = sortableHandle(() => (
            <div className="dragndrop">
                <span className="material-icons">drag_indicator</span>
            </div>
        ));
        const SortableElement = sortableElement(({ todo, onBlur, ref_editableTodo, handler_toggleTodo, handler_clearTodo, handler_modifyTodo }) => (
            <li className="todo">
                <DragHandle />
                <div className="checkbox" onClick={handler_toggleTodo}>
                    <input type="checkbox" checked={todo.complete} onChange={handler_toggleTodo} />
                    <span className="checkmark"></span>
                </div>
                <label className="label">
                    <TextareaAutosize defaultValue={todo.name} onBlur={onBlur} ref={ref_editableTodo} onChange={handler_modifyTodo} minRows={1} maxLength="100" />
                </label>
                <button className="button clear" onClick={handler_clearTodo}>
                    <span className="material-icons">clear</span>
                </button>
            </li>
        ));



// MAIN CONTENT - FUNCTION / COMPONENT
    function Todo({ index, todo, toggleTodo, clearTodo, modifyTodo }) {


        // TOOL : useRef => Info : To get fields value
            let ref_editableTodo = useRef();


        // EVENT(S)
            const onBlur = (event) => {
                // Info : OnBlur = onFocusOut (in React)
                if (ref_editableTodo.current.value === "") {
                    clearTodo(todo.id);
                }
            }


        // FUNCTION(S)
            const handler_toggleTodo = () => {
                toggleTodo(todo.id);
            }
            const handler_clearTodo = () => {
                clearTodo(todo.id);
            }
            const handler_modifyTodo = () => {
                modifyTodo(todo.id, ref_editableTodo.current.value);
            }


        // RETURN
            return (
                <SortableElement
                    index={index}
                    todo={todo}
                    onBlur={onBlur}
                    ref_editableTodo={ref_editableTodo}
                    handler_toggleTodo={handler_toggleTodo}
                    handler_clearTodo={handler_clearTodo}
                    handler_modifyTodo={handler_modifyTodo} />
            )
    }
    export default Todo;



// PROPTYPES
    Todo.propTypes = {
        index: PropTypes.number,
        todo: PropTypes.object,
        toggleTodo: PropTypes.func,
        clearTodo: PropTypes.func,
        modifyTodo: PropTypes.func
    }
